import { NdmsFormControlComponent } from '../ndms-form-control/ndms-form-control.component';
import {Component, OnInit, ViewContainerRef, ViewChild, Input, ElementRef, Renderer2, EventEmitter, Output} from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { LookupViewModel } from '../../view-models/lookup.view-model';

@Component({
  selector: 'ndms-select',
  templateUrl: './ndms-select.component.html',
  styleUrls: ['./ndms-select.component.scss']
})
export class NdmsSelectComponent extends NdmsFormControlComponent implements OnInit {

  constructor(viewContainerRef: ViewContainerRef) {
    super(viewContainerRef);
   }
  ngOnInit() {
    
  }

  @Input() hasNullValue: boolean = true;
  @Input() defaultValue?: string =undefined;
  @Input() label: string;
  @Input() lookup:string;
  @Input() required: string;
  @Output() select: EventEmitter<any> = new EventEmitter<any>();

  @ViewChild('selectElement') selectElement: ElementRef;

  get lookups() {
    return this.getLookups(this.lookup);
  }

  compareFn(c1: any, c2: any): boolean {
    if (c1 && c2 && c1.id && c2.id) {
      return c1.id === c2.id;
    }
    if (c1 && c2 && c1.key && c2.key) {
      return c1.key === c2.key;
    }
    return c1 === c2;
  }
  onSelectFinish($event) {
    this.select.emit($event);
  }
  getText() {
    if(!this.value || !this.value.key)
    {
      return 'N/A';
    }
    return this.value.description;
  }

  setSelection(key) {
    this.group.controls[this.field].setValue(this.lookups.find((l) => l.key == key));
  }
}
